import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./performanceApiClient";

export const listCategories = async (params = {}) =>
  getRequest("/competencies/categories", { params });

export const createCategory = async (payload) =>
  postRequest("/competencies/categories", payload);

export const updateCategory = async (categoryId, payload) =>
  putRequest(`/competencies/categories/${categoryId}`, payload);

export const archiveCategory = async (categoryId) =>
  deleteRequest(`/competencies/categories/${categoryId}`);

export const listCompetencies = async (params = {}) =>
  getRequest("/competencies", { params });

export const createCompetency = async (payload) =>
  postRequest("/competencies", payload);

export const updateCompetency = async (competencyId, payload) =>
  putRequest(`/competencies/${competencyId}`, payload);

export const archiveCompetency = async (competencyId) =>
  deleteRequest(`/competencies/${competencyId}`);

export default {
  listCategories,
  createCategory,
  updateCategory,
  archiveCategory,
  listCompetencies,
  createCompetency,
  updateCompetency,
  archiveCompetency,
};
